const PREFIX = "hlss-studio-draft-v1:"

export class DraftStore {
  constructor(storage) { this.storage = storage }

  read(key) {
    try {
      const value = JSON.parse(this.storage.getItem(PREFIX + key))
      if (typeof value?.text !== "string" || !Array.isArray(value.choices) ||
          !value.choices.every(choice => typeof choice === "string")) return null
      return value
    } catch { return null }
  }

  write(key, value) {
    try { this.storage.setItem(PREFIX + key, JSON.stringify(value)) } catch { /* Storage may be disabled. */ }
  }

  remove(key) {
    try { this.storage.removeItem(PREFIX + key) } catch { /* Storage may be disabled. */ }
  }

  clear() {
    try {
      for (let index = this.storage.length - 1; index >= 0; index--) {
        const key = this.storage.key(index)
        if (key?.startsWith(PREFIX)) this.storage.removeItem(key)
      }
    } catch { /* Storage may be disabled. */ }
  }
}

export function isLogoutRequest(url) {
  try { return /\/(?:logout|sign_out)\/?$/.test(new URL(url).pathname) }
  catch { return false }
}

export function sessionDrafts() {
  try { return new DraftStore(window.sessionStorage) }
  catch { return new DraftStore(null) }
}
